import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

function token() { return localStorage.getItem('token'); }
function getUsuario() {
  try {
    const t = localStorage.getItem('token');
    // JWT usa base64url: normaliza antes do atob (senão '-'/'_' quebram a decodificação)
    const p = JSON.parse(atob(t.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return { id: p.id || p._id || '', nome: localStorage.getItem('nomeUsuario') || '' };
  } catch { return { id: '', nome: '' }; }
}

function fmtData(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

const FONTES = ['Arial', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New', 'Trebuchet MS', 'Comic Sans MS'];
const TAMANHOS = ['10', '12', '14', '16', '18', '20', '24', '28', '32', '36', '48'];

function BtnTool({ title, onClick, active, children }) {
  return (
    <button
      onMouseDown={e => { e.preventDefault(); onClick && onClick(); }}
      title={title}
      style={{
        background: active ? '#0a1628' : '#f3f4f6',
        color: active ? '#fff' : '#374151',
        border: '1px solid #d1d5db',
        borderRadius: 4, padding: '3px 7px', fontSize: 13,
        cursor: 'pointer', fontWeight: 600, lineHeight: 1.4,
        minWidth: 28, display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
      {children}
    </button>
  );
}

export default function Anotacoes() {
  const [lista, setLista] = useState([]);
  const [selecionada, setSelecionada] = useState(null);
  const [titulo, setTitulo] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [busca, setBusca] = useState('');
  const [confirmExcluir, setConfirmExcluir] = useState(null);
  const editorRef = useRef(null);
  const saveTimer = useRef(null);
  const usuario = getUsuario();
  // /anotacoes?nota=ID abre direto numa anotação (link do painel de favoritos da Home)
  const [searchParams] = useSearchParams();
  const abriuPorLink = useRef(false);

  const carregar = useCallback(async () => {
    const r = await fetch('/anotacoes', { headers: { Authorization: `Bearer ${token()}` } });
    const data = await r.json();
    setLista(data);
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  useEffect(() => {
    const id = searchParams.get('nota');
    if (!id || abriuPorLink.current || !lista.length) return;
    const nota = lista.find(n => n._id === id);
    if (nota) { abriuPorLink.current = true; selecionar(nota); }
  }, [lista, searchParams]);

  function selecionar(nota) {
    setSelecionada(nota);
    setTitulo(nota.titulo);
    setTimeout(() => {
      if (editorRef.current) editorRef.current.innerHTML = nota.conteudo || '';
    }, 0);
  }

  async function novaNota() {
    const r = await fetch('/anotacoes', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ titulo: 'Nova anotação', conteudo: '', usuario_id: usuario.id, usuario_nome: usuario.nome }),
    });
    const nova = await r.json();
    setLista(prev => [nova, ...prev]);
    selecionar(nova);
  }

  function agendarSalvar(novoTitulo, novoConteudo) {
    if (!selecionada) return;
    clearTimeout(saveTimer.current);
    saveTimer.current = setTimeout(() => salvar(novoTitulo, novoConteudo), 1200);
  }

  async function salvar(t, c) {
    if (!selecionada) return;
    setSalvando(true);
    const conteudo = c !== undefined ? c : (editorRef.current?.innerHTML || '');
    const tituloFinal = t !== undefined ? t : titulo;
    const r = await fetch(`/anotacoes/${selecionada._id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ titulo: tituloFinal, conteudo }),
    });
    const atualizada = await r.json();
    setLista(prev => prev.map(n => n._id === atualizada._id ? atualizada : n));
    setSelecionada(atualizada);
    setSalvando(false);
  }

  async function excluir(id) {
    await fetch(`/anotacoes/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token()}` } });
    setLista(prev => prev.filter(n => n._id !== id));
    if (selecionada?._id === id) {
      setSelecionada(null);
      setTitulo('');
      if (editorRef.current) editorRef.current.innerHTML = '';
    }
    setConfirmExcluir(null);
  }

  // ⭐ Favorita: aparece no painel de favoritos da Home (só as do próprio usuário)
  async function alternarFavorita(nota) {
    const favorita = !nota.favorita;
    setLista(prev => prev.map(n => n._id === nota._id ? { ...n, favorita } : n));
    if (selecionada?._id === nota._id) setSelecionada(s => ({ ...s, favorita }));
    await fetch(`/anotacoes/${nota._id}/favorita`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ favorita }),
    }).catch(() => {});
  }

  function cmd(command, value = null) {
    editorRef.current?.focus();
    document.execCommand(command, false, value);
  }

  function isAtivo(command) {
    try { return document.queryCommandState(command); } catch { return false; }
  }

  const listaFiltrada = lista.filter(n =>
    (n.titulo || '').toLowerCase().includes(busca.toLowerCase()) ||
    (n.conteudo || '').replace(/<[^>]*>/g, '').toLowerCase().includes(busca.toLowerCase())
  ).sort((a, b) => (b.favorita ? 1 : 0) - (a.favorita ? 1 : 0)); // ⭐ primeiro, resto na ordem de edição

  return (
    <div style={{ display: 'flex', height: 'calc(100vh - 96px)', gap: 0, borderRadius: 8, overflow: 'hidden', border: '1px solid #d1d5db', background: '#fff' }}>

      {/* Sidebar */}
      <div style={{ width: 260, flexShrink: 0, borderRight: '1px solid #e5e7eb', display: 'flex', flexDirection: 'column', background: '#f9fafb' }}>
        <div style={{ padding: '10px 10px 6px', borderBottom: '1px solid #e5e7eb' }}>
          <button onClick={novaNota} style={{ width: '100%', background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 0', fontSize: 13, fontWeight: 700, cursor: 'pointer', marginBottom: 8 }}>
            + Nova Anotação
          </button>
          <input
            value={busca} onChange={e => setBusca(e.target.value)}
            placeholder="Buscar anotações..."
            style={{ width: '100%', padding: '5px 8px', borderRadius: 5, border: '1px solid #d1d5db', fontSize: 12, boxSizing: 'border-box' }}
          />
        </div>
        <div style={{ flex: 1, overflowY: 'auto' }}>
          {listaFiltrada.length === 0 && (
            <div style={{ textAlign: 'center', padding: '24px 12px', color: '#9ca3af', fontSize: 12 }}>
              {busca ? 'Nenhuma anotação encontrada' : 'Nenhuma anotação ainda'}
            </div>
          )}
          {listaFiltrada.map(nota => (
            <div key={nota._id}
              onClick={() => selecionar(nota)}
              style={{
                padding: '10px 12px', borderBottom: '1px solid #e5e7eb', cursor: 'pointer',
                background: selecionada?._id === nota._id ? '#e0e7ff' : '#fff',
                borderLeft: selecionada?._id === nota._id ? '3px solid #0a1628' : '3px solid transparent',
              }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 4 }}>
                <div style={{ fontWeight: 600, fontSize: 13, color: '#0a1628', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>{nota.titulo}</div>
                <button
                  onClick={e => { e.stopPropagation(); alternarFavorita(nota); }}
                  title={nota.favorita ? 'Tirar dos favoritos' : 'Marcar como favorita (aparece no painel ⭐ da Home)'}
                  style={{ background: 'none', border: 'none', color: nota.favorita ? '#f59e0b' : '#c3cad3', cursor: 'pointer', fontSize: 14, padding: '0 2px', flexShrink: 0, lineHeight: 1 }}>
                  {nota.favorita ? '⭐' : '☆'}
                </button>
                <button
                  onClick={e => { e.stopPropagation(); setConfirmExcluir(nota._id); }}
                  style={{ background: 'none', border: 'none', color: '#dc2626', cursor: 'pointer', fontSize: 14, padding: '0 2px', flexShrink: 0, lineHeight: 1 }}
                  title="Excluir">✕</button>
              </div>
              <div style={{ fontSize: 11, color: '#6b7280', marginTop: 3 }}>{fmtData(nota.atualizado_em)}</div>
              <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {(nota.conteudo || '').replace(/<[^>]*>/g, '').slice(0, 60)}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Editor */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        {!selecionada ? (
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#9ca3af' }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>📝</div>
            <div style={{ fontSize: 15, fontWeight: 600, color: '#374151' }}>Selecione uma anotação</div>
            <div style={{ fontSize: 13, marginTop: 4 }}>ou crie uma nova</div>
            <button onClick={novaNota} style={{ marginTop: 16, background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 20px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
              + Nova Anotação
            </button>
          </div>
        ) : (
          <>
            {/* Título */}
            <div style={{ padding: '10px 16px 0', borderBottom: '1px solid #e5e7eb' }}>
              <input
                value={titulo}
                onChange={e => { setTitulo(e.target.value); agendarSalvar(e.target.value, undefined); }}
                placeholder="Título da anotação"
                style={{ width: '100%', border: 'none', outline: 'none', fontSize: 20, fontWeight: 700, color: '#0a1628', background: 'transparent', paddingBottom: 8, boxSizing: 'border-box' }}
              />
            </div>

            {/* Toolbar */}
            <div style={{ padding: '6px 12px', borderBottom: '1px solid #e5e7eb', display: 'flex', flexWrap: 'wrap', gap: 4, alignItems: 'center', background: '#f9fafb' }}>
              {/* Fonte */}
              <select onMouseDown={e => e.stopPropagation()} onChange={e => cmd('fontName', e.target.value)}
                style={{ height: 26, borderRadius: 4, border: '1px solid #d1d5db', fontSize: 12, padding: '0 4px', cursor: 'pointer' }}>
                {FONTES.map(f => <option key={f} value={f}>{f}</option>)}
              </select>

              {/* Tamanho */}
              <select onMouseDown={e => e.stopPropagation()} onChange={e => cmd('fontSize', e.target.value)}
                style={{ height: 26, width: 52, borderRadius: 4, border: '1px solid #d1d5db', fontSize: 12, padding: '0 2px', cursor: 'pointer' }}>
                {TAMANHOS.map(t => <option key={t} value={t}>{t}</option>)}
              </select>

              <div style={{ width: 1, height: 22, background: '#d1d5db', margin: '0 2px' }} />

              <BtnTool title="Negrito (Ctrl+B)" onClick={() => cmd('bold')} active={isAtivo('bold')}><b>N</b></BtnTool>
              <BtnTool title="Itálico (Ctrl+I)" onClick={() => cmd('italic')} active={isAtivo('italic')}><i>I</i></BtnTool>
              <BtnTool title="Sublinhado (Ctrl+U)" onClick={() => cmd('underline')} active={isAtivo('underline')}><u>S</u></BtnTool>
              <BtnTool title="Tachado" onClick={() => cmd('strikeThrough')} active={isAtivo('strikeThrough')}><s>T</s></BtnTool>

              <div style={{ width: 1, height: 22, background: '#d1d5db', margin: '0 2px' }} />

              <BtnTool title="Alinhar à esquerda" onClick={() => cmd('justifyLeft')}>⬅</BtnTool>
              <BtnTool title="Centralizar" onClick={() => cmd('justifyCenter')}>☰</BtnTool>
              <BtnTool title="Alinhar à direita" onClick={() => cmd('justifyRight')}>➡</BtnTool>
              <BtnTool title="Justificar" onClick={() => cmd('justifyFull')}>≡</BtnTool>

              <div style={{ width: 1, height: 22, background: '#d1d5db', margin: '0 2px' }} />

              <BtnTool title="Lista com marcadores" onClick={() => cmd('insertUnorderedList')}>• Lista</BtnTool>
              <BtnTool title="Lista numerada" onClick={() => cmd('insertOrderedList')}>1. Lista</BtnTool>

              <div style={{ width: 1, height: 22, background: '#d1d5db', margin: '0 2px' }} />

              {/* Cor do texto */}
              <label title="Cor do texto" style={{ display: 'flex', alignItems: 'center', gap: 3, cursor: 'pointer', fontSize: 12, color: '#374151', fontWeight: 600 }}>
                A
                <input type="color" defaultValue="#000000"
                  onChange={e => cmd('foreColor', e.target.value)}
                  style={{ width: 22, height: 22, border: 'none', padding: 0, cursor: 'pointer', borderRadius: 3 }} />
              </label>

              {/* Cor de fundo */}
              <label title="Cor de fundo do texto" style={{ display: 'flex', alignItems: 'center', gap: 3, cursor: 'pointer', fontSize: 12, color: '#374151', fontWeight: 600 }}>
                🖍
                <input type="color" defaultValue="#ffff00"
                  onChange={e => cmd('hiliteColor', e.target.value)}
                  style={{ width: 22, height: 22, border: 'none', padding: 0, cursor: 'pointer', borderRadius: 3 }} />
              </label>

              <div style={{ width: 1, height: 22, background: '#d1d5db', margin: '0 2px' }} />

              <BtnTool title="Desfazer (Ctrl+Z)" onClick={() => cmd('undo')}>↩</BtnTool>
              <BtnTool title="Refazer (Ctrl+Y)" onClick={() => cmd('redo')}>↪</BtnTool>

              <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8 }}>
                {salvando && <span style={{ fontSize: 11, color: '#9ca3af' }}>Salvando...</span>}
                <button
                  onClick={() => salvar()}
                  style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 14px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
                  💾 Salvar
                </button>
              </div>
            </div>

            {/* Área de texto */}
            <div
              ref={editorRef}
              contentEditable
              suppressContentEditableWarning
              onInput={() => agendarSalvar(undefined, editorRef.current?.innerHTML)}
              style={{
                flex: 1, padding: '20px 32px', outline: 'none', overflowY: 'auto',
                fontSize: 14, lineHeight: 1.8, color: '#1f2937',
                fontFamily: 'Arial, sans-serif', minHeight: 0,
              }}
            />

            {/* Rodapé */}
            <div style={{ padding: '4px 16px', borderTop: '1px solid #e5e7eb', fontSize: 11, color: '#9ca3af', display: 'flex', justifyContent: 'space-between' }}>
              <span>Criado: {fmtData(selecionada.criado_em)}</span>
              <span>Última edição: {fmtData(selecionada.atualizado_em)}</span>
            </div>
          </>
        )}
      </div>

      {/* Modal confirmar exclusão */}
      {confirmExcluir && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 8, padding: 24, maxWidth: 360, width: '90%', textAlign: 'center' }}>
            <div style={{ fontSize: 36, marginBottom: 10 }}>🗑️</div>
            <p style={{ fontSize: 14, color: '#374151', marginBottom: 20 }}>Tem certeza que deseja excluir esta anotação?</p>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
              <button onClick={() => setConfirmExcluir(null)} style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', padding: '7px 20px', borderRadius: 6, fontSize: 13, cursor: 'pointer' }}>Cancelar</button>
              <button onClick={() => excluir(confirmExcluir)} style={{ background: '#dc2626', color: '#fff', border: 'none', padding: '7px 20px', borderRadius: 6, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>Excluir</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
